export default {"src":"/_next/static/media/Crif_logo.8de65925.svg","height":18,"width":52,"blurWidth":0,"blurHeight":0};